import { Props_SnippetContent } from './Content.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph, linkProps  } = props

    const classHeadingVisibility: string = heading.visibility?.value ? 'snippet-content__heading--visible' : 'snippet-content__heading--hidden'
    const linkAlignmentClass: string = linkProps.alignment?.value ? `snippet-content__link-container--${linkProps.alignment.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className={`snippet-content__content ${paragraph?.weight?.value ? `snippet-content__content--${paragraph.weight.value}` : 'snippet-content__content--regular'}`}>
                    {paragraph.text.value && CompileMarkdown(paragraph?.text?.value)}
                </div>
                <div className={`snippet-content__link-container ${linkAlignmentClass}`}>
                    {repeatable_link.map(({ linkHref, linkTarget, linkText, linkStyle }, index) => (
                        <SnippetLink
                            key={`link-${linkHref} ${index}`}
                            linkStyles={linkStyle?.value}
                            className="snippet-content__link"
                            url={linkHref?.value}
                            openInNewTab={linkTarget?.value}
                        >
                            {linkText?.value}
                        </SnippetLink>
                    ))}
                </div>

            </div>
        </section>
    )
}

export default SnippetContent
